<template>
  <div>
    <b-row v-if="id" class="mb-3">
      <b-col cols="12">
        <b-button variant="primary" @click="generateToken"
          ><i class="fas fa-qrcode mr-2" />{{
            $t("actions.generate_token")
          }}</b-button
        >
        <b-button variant="default" class="ml-3" @click="ladeCheckin"
          ><i class="fas fa-sync"
        /></b-button>
        <b-link
          href="/mitarbeiterverwaltun/stammdaten/"
          target="_top"
          class="btn btn-default ml-3"
          ><i class="fas fa-list mr-3" />{{ $t("actions.to_list") }}</b-link
        >
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-alert
          show
          variant="warning"
          v-html="$t('formular.warn_readonly')"
        ></b-alert>
      </b-col>
    </b-row>
    <bx-box variant="gray" header-class="col-md-6" class="mb-3">
      <template #header>
        <h3>{{ $t("formular.employee.checkin.headline") }}</h3>
      </template>
      <bx-box variant="white" class="mb-1" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>
          <h5>{{ $t("formular.employee.checkin.personal.headline") }}</h5>
          <b-row>
            <b-col md="4">
              <b-form-group :label="formular_text('personal.personal_number')">
                <b-form-input
                  v-model="personalnummer"
                  :disabled="readonly"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="formular_text('personal.first_name')"
                :state="input_state('vorname')"
                :invalid-feedback="formular_text('personal.first_name_invalid')"
              >
                <b-form-input
                  v-model="vorname"
                  :disabled="readonly"
                  :state="input_state('vorname')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('personal.last_name')"
                :state="input_state('nachname')"
                :invalid-feedback="formular_text('personal.last_name_invalid')"
              >
                <b-form-input
                  v-model="nachname"
                  :disabled="readonly"
                  :state="input_state('nachname')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="formular_text('personal.birthdate')"
                :state="input_state('geburtsdatum')"
                :invalid-feedback="formular_text('personal.birthdate_invalid')"
              >
                <b-form-input
                  v-model="geburtsdatum"
                  :disabled="readonly"
                  :state="input_state('geburtsdatum')"
                  type="date"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group :label="formular_text('personal.activity')">
                <v-select
                  v-model="taetigkeitsbereich_id"
                  :options="taetigkeit_auswahl"
                  :disabled="readonly"
                  label="titel"
                  :reduce="(o) => o.id"
                  :clearable="false"
                  :searchable="false"
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-skeleton-wrapper>
      </bx-box>
      <bx-box variant="white" class="mb-1" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>
          <h5>{{ formular_text("contact.headline") }}</h5>
          <b-row>
            <b-col md="12">
              <b-form-group :label="formular_text('personal.street')">
                <b-form-input
                  v-model="strasse"
                  :disabled="readonly"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="formular_text('personal.postcode')">
                <b-form-input v-model="plz" :disabled="readonly"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="9">
              <b-form-group :label="formular_text('personal.city')">
                <b-form-input v-model="ort" :disabled="readonly"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="formular_text('personal.phone')">
                <b-form-input
                  v-model="telefon_privat"
                  :disabled="readonly"
                  type="tel"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :label="formular_text('personal.mail')">
                <b-form-input
                  v-model="email_privat"
                  :disabled="readonly"
                  type="email"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-skeleton-wrapper>
      </bx-box>
      <bx-box variant="white" class="mb-1" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>
          <b-row>
            <b-col md="6">
              <b-form-group :label="formular_text('working_stuff.tax_class')">
                <b-form-input
                  v-model="steuerklasse"
                  type="number"
                  :disabled="readonly"
                  min="1"
                  max="6"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('working_stuff.social_security_number')"
              >
                <b-form-input
                  v-model="sv_nummer"
                  :disabled="readonly"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('working_stuff.health_insurance')"
              >
                <b-form-input
                  v-model="krankenkasse"
                  :disabled="readonly"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('working_stuff.start_of_work')"
              >
                <b-form-input
                  v-model="eintritt"
                  :disabled="readonly"
                  type="date"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="formular_text('working_stuff.company')">
                <v-select
                  v-model="firma_id"
                  :options="firma_auwahl"
                  :disabled="readonly"
                  label="titel"
                  :reduce="(o) => o.id"
                  :clearable="false"
                  :searchable="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="formular_text('working_stuff.branch')">
                <v-select
                  v-model="standort_id"
                  :options="standort_auswahl"
                  label="titel"
                  :reduce="(o) => o.id"
                  :clearable="false"
                  :searchable="false"
                  :disabled="readonly"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-skeleton-wrapper>
      </bx-box>
      <bx-box variant="white" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>
          <h5>{{ $t("formular.employee.checkin.qualifications.headline") }}</h5>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="formular_text('qualifications.facharbeiterzeugnisse')"
              >
                <b-form-textarea
                  v-model="facharbeiterzeugnis"
                  :disabled="readonly"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('qualifications.meisterbriefe')"
                :disabled="readonly"
              >
                <b-form-textarea v-model="meisterbriefe"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('qualifications.zertifikate')"
                :disabled="readonly"
              >
                <b-form-textarea v-model="zertifikate"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="
                  formular_text('qualifications.zusaetzliche_berechtigungen')
                "
              >
                <b-form-textarea
                  v-model="zusaetzliche_berechtigungen"
                  :disabled="readonly"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="formular_text('qualifications.fuehrerschein')"
              >
                <b-form-textarea
                  v-model="fuehrerschein"
                  :disabled="readonly"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="
                  formular_text('qualifications.personenbefoerderungsschein')
                "
              >
                <b-form-textarea
                  :disabled="readonly"
                  v-model="personenbefoerderungsschein"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="
                  formular_text('qualifications.medizinische_untersuchungen')
                "
              >
                <b-form-textarea
                  :disabled="readonly"
                  v-model="medizinische_untersuchungen"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-skeleton-wrapper>
      </bx-box>
    </bx-box>
    <b-button
      v-if="!id"
      variant="primary"
      class="w-100"
      :disabled="errors_activated && $v.$invalid"
      @click="speichern"
    >
      {{ $t("actions.save") }}
    </b-button>

    <token-invalid-modal ref="tokenInvalidModal"></token-invalid-modal>
    <speichern-erfolgreich-modal
      ref="speichernErfolgreichModal"
    ></speichern-erfolgreich-modal>
    <unexpected-error-modal ref="unexpectedErrorModal"></unexpected-error-modal>
    <validation-failure-modal
      ref="validationFailureModal"
    ></validation-failure-modal>
  </div>
</template>

<script>
  import formular from "@m/formular";
  import api from "@a/index";
  import { DateTime } from "luxon";
  import EventBus from "@/event-bus.js";
  import { OPEN_ACCESS_LAYER } from "@/event-bus";
  import { formularKeys } from "@/services/formulars/formularKeyDecoder";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: {},
    name: "EmployeeCheckin",
    metaInfo() {
      const title = this.formular_text("headline");
      return {
        titleTemplate: () => {
          return title;
        },
      };
    },
    mixins: [formular],
    data() {
      return {
        loading: true,
        personalnummer: null,
        vorname: null,
        nachname: null,
        strasse: null,
        ort: null,
        plz: null,
        email_privat: null,
        steuerklasse: null,
        krankenkasse: null,
        eintritt: null,
        geburtsdatum: null,
        firma_id: null,
        standort_id: null,
        taetigkeitsbereich_id: null,
        sv_nummer: null,
        telefon_privat: null,
        facharbeiterzeugnis: null,
        meisterbriefe: null,
        zertifikate: null,
        zusaetzliche_berechtigungen: null,
        fuehrerschein: null,
        personenbefoerderungsschein: null,
        medizinische_untersuchungen: null,
        firma_auwahl: [],
        standort_auswahl: [],
        taetigkeit_auswahl: [],
      };
    },
    validations: {
      vorname: {
        required,
      },
      nachname: {
        required,
      },
      geburtsdatum: {
        required,
      },
    },
    computed: {
      formular_key() {
        return "employee.checkin";
      },
    },
    async created() {
      await this.ladeCheckin();
    },
    methods: {
      async ladeCheckin() {
        let loader = this.$loading.show({});
        try {
          let response = this.id
            ? await api.privateFormular.employee.checkin.getById(this.id)
            : await api.publicFormluar.employee.checkin.get(this.token);

          this.initialize(response.data);
        } catch (e) {
          if (e.response.status === 401) {
            this.$refs.tokenInvalidModal.show();
          }
        } finally {
          this.loading = false;
          loader.hide();
        }
      },
      async speichern() {
        if (this.$v.$invalid) {
          this.errors_activated = true;
          this.$refs.validationFailureModal.show();
        } else {
          let loader = this.$loading.show({});

          try {
            let json = {
              personalnummer: this.personalnummer,
              vorname: this.vorname,
              nachname: this.nachname,
              strasse: this.strasse,
              ort: this.ort,
              plz: this.plz,
              email_privat: this.email_privat,
              steuerklasse: this.steuerklasse,
              krankenkasse: this.krankenkasse,
              eintritt: this.eintritt
                ? DateTime.fromFormat(this.eintritt, "yyyy-MM-dd").ts
                : null,
              geburtsdatum: this.geburtsdatum
                ? DateTime.fromFormat(this.geburtsdatum, "yyyy-MM-dd").ts
                : null,
              firma_id: this.firma_id,
              standort_id: this.standort_id,
              taetigkeitsbereich_id: this.taetigkeitsbereich_id,
              sv_nummer: this.sv_nummer,
              telefon_privat: this.telefon_privat,
              facharbeiterzeugnis: this.facharbeiterzeugnis,
              meisterbriefe: this.meisterbriefe,
              zertifikate: this.zertifikate,
              zusaetzliche_berechtigungen: this.zusaetzliche_berechtigungen,
              fuehrerschein: this.fuehrerschein,
              personenbefoerderungsschein: this.personenbefoerderungsschein,
              medizinische_untersuchungen: this.medizinische_untersuchungen,
            };
            await api.publicFormluar.employee.checkin.post(json, this.token);

            this.$refs.speichernErfolgreichModal.show(false);
          } catch (e) {
            if (e.response.status === 401) {
              this.$refs.tokenInvalidModal.show();
            } else {
              this.$refs.unexpectedErrorModal.shwo();
            }
          } finally {
            loader.hide();
          }
        }
      },
      initialize(checkin) {
        this.taetigkeit_auswahl = checkin.kategorien.taetigkeitsbereiche;
        this.standort_auswahl = checkin.kategorien.standorte;
        this.firma_auwahl = checkin.kategorien.firmen;

        this.personalnummer = checkin.data.personalnummer;
        this.vorname = checkin.data.vorname;
        this.nachname = checkin.data.nachname;
        this.taetigkeitsbereich_id = checkin.data.taetigkeitsbereich_id;
        this.geburtsdatum = checkin.data.geburtsdatum
          ? DateTime.fromMillis(checkin.data.geburtsdatum).toFormat("yyyy-MM-dd")
          : null;
        this.strasse = checkin.data.strasse;
        this.plz = checkin.data.plz;
        this.ort = checkin.data.ort;
        this.email_privat = checkin.data.email_privat;
        this.telefon_privat = checkin.data.telefon_privat;
        this.steuerklasse = checkin.data.steuerklasse;
        this.sv_nummer = checkin.data.sv_nummer;
        this.krankenkasse = checkin.data.krankenkasse;
        this.eintritt = checkin.data.eintritt
          ? DateTime.fromMillis(checkin.data.eintritt).toFormat("yyyy-MM-dd")
          : null;
        this.firma_id = checkin.data.firma_id;
        this.standort_id = checkin.data.standort_id;

        this.facharbeiterzeugnis = checkin.data.facharbeiterzeugnis;
        this.meisterbriefe = checkin.data.meisterbriefe;
        this.zertifikate = checkin.data.zertifikate;
        this.zusaetzliche_berechtigungen =
          checkin.data.zusaetzliche_berechtigungen;
        this.fuehrerschein = checkin.data.fuehrerschein;
        this.personenbefoerderungsschein =
          checkin.data.personenbefoerderungsschein;
        this.medizinische_untersuchungen =
          checkin.data.medizinische_untersuchungen;
      },
      generateToken() {
        EventBus.$emit(
          OPEN_ACCESS_LAYER,
          formularKeys.einstellungsformular,
          "Einstellungsformular",
          DateTime.local().plus({ days: 1 }),
          this.id
        );
      },
    },
  };
</script>

<style>
</style>
